import {
  ENQUEUE_PUBLISH_JOB,
  REMOVE_PUBLISH_JOB,
  UPDATE_PUBLISH_JOB_PROGRESS,
  MARK_BANNER_LIST_STALE,
  CLEAR_BANNER_LIST_STALE,
  MARK_TEMPLATE_LIST_STALE,
  CLEAR_TEMPLATE_LIST_STALE,
  MARK_PARTNERS_LIST_STALE,
  CLEAR_PARTNERS_LIST_STALE,
  MARK_BRANDS_LIST_STALE,
  CLEAR_BRANDS_LIST_STALE,
  MARK_DEPARTMENTS_LIST_STALE,
  CLEAR_DEPARTMENTS_LIST_STALE,
  MARK_PAGES_LIST_STALE,
  CLEAR_PAGES_LIST_STALE,
  MARK_CAREERS_LIST_STALE,
  CLEAR_CAREERS_LIST_STALE,
  MARK_CAREER_APPLICATIONS_LIST_STALE,
  CLEAR_CAREER_APPLICATIONS_LIST_STALE,
  MARK_OUR_TEAM_LIST_STALE,
  CLEAR_OUR_TEAM_LIST_STALE,
  MARK_PROJECTS_LIST_STALE,
  CLEAR_PROJECTS_LIST_STALE,
  MARK_CATEGORIES_LIST_STALE,
  CLEAR_CATEGORIES_LIST_STALE,
  MARK_WIDGETS_LIST_STALE,
  CLEAR_WIDGETS_LIST_STALE,
  MARK_SEO_LIST_STALE,
  CLEAR_SEO_LIST_STALE,
  MARK_INFORMATION_POLICY_LIST_STALE,
  CLEAR_INFORMATION_POLICY_LIST_STALE,
  MARK_ADMIN_SETTINGS_STALE,
  CLEAR_ADMIN_SETTINGS_STALE,
  MARK_CONFIG_SETTINGS_STALE,
  CLEAR_CONFIG_SETTINGS_STALE,
} from '../constants/PendingPublish';

const initState = {
  jobs: [],
  bannerListStale: false,
  templateListStale: false,
  partnersListStale: false,
  brandsListStale: false,
  departmentsListStale: false,
  pagesListStale: false,
  careersListStale: false,
  careerApplicationsListStale: false,
  ourTeamListStale: false,
  projectsListStale: false,
  categoriesListStale: false,
  widgetsListStale: false,
  seoListStale: false,
  informationPolicyListStale: false,
  adminSettingsStale: false,
  configSettingsStale: false,
};

const pendingPublish = (state = initState, action) => {
  switch (action.type) {
    case ENQUEUE_PUBLISH_JOB:
      return {
        ...state,
        jobs: [
          {
            ...action.payload,
            status: 'pending',
            phase: 'queued',
            percent: 0,
            error: null,
          },
          ...state.jobs,
        ],
      };
    case UPDATE_PUBLISH_JOB_PROGRESS: {
      const { id, percent, phase, status } = action.payload;
      return {
        ...state,
        jobs: state.jobs.map((job) =>
          job.id === id
            ? {
                ...job,
                ...(typeof percent === 'number' ? { percent } : {}),
                ...(phase ? { phase } : {}),
                ...(status ? { status } : {}),
              }
            : job,
        ),
      };
    }
    case REMOVE_PUBLISH_JOB:
      return {
        ...state,
        jobs: state.jobs.filter((job) => job.id !== action.payload),
      };
    case MARK_BANNER_LIST_STALE:
      return {
        ...state,
        bannerListStale: true,
      };
    case CLEAR_BANNER_LIST_STALE:
      return {
        ...state,
        bannerListStale: false,
      };
    case MARK_TEMPLATE_LIST_STALE:
      return {
        ...state,
        templateListStale: true,
      };
    case CLEAR_TEMPLATE_LIST_STALE:
      return {
        ...state,
        templateListStale: false,
      };
    case MARK_PARTNERS_LIST_STALE:
      return {
        ...state,
        partnersListStale: true,
      };
    case CLEAR_PARTNERS_LIST_STALE:
      return {
        ...state,
        partnersListStale: false,
      };
    case MARK_BRANDS_LIST_STALE:
      return {
        ...state,
        brandsListStale: true,
      };
    case CLEAR_BRANDS_LIST_STALE:
      return {
        ...state,
        brandsListStale: false,
      };
    case MARK_DEPARTMENTS_LIST_STALE:
      return {
        ...state,
        departmentsListStale: true,
      };
    case CLEAR_DEPARTMENTS_LIST_STALE:
      return {
        ...state,
        departmentsListStale: false,
      };
    case MARK_PAGES_LIST_STALE:
      return {
        ...state,
        pagesListStale: true,
      };
    case CLEAR_PAGES_LIST_STALE:
      return {
        ...state,
        pagesListStale: false,
      };
    case MARK_CAREERS_LIST_STALE:
      return {
        ...state,
        careersListStale: true,
      };
    case CLEAR_CAREERS_LIST_STALE:
      return {
        ...state,
        careersListStale: false,
      };
    case MARK_CAREER_APPLICATIONS_LIST_STALE:
      return {
        ...state,
        careerApplicationsListStale: true,
      };
    case CLEAR_CAREER_APPLICATIONS_LIST_STALE:
      return {
        ...state,
        careerApplicationsListStale: false,
      };
    case MARK_OUR_TEAM_LIST_STALE:
      return {
        ...state,
        ourTeamListStale: true,
      };
    case CLEAR_OUR_TEAM_LIST_STALE:
      return {
        ...state,
        ourTeamListStale: false,
      };
    case MARK_PROJECTS_LIST_STALE:
      return {
        ...state,
        projectsListStale: true,
      };
    case CLEAR_PROJECTS_LIST_STALE:
      return {
        ...state,
        projectsListStale: false,
      };
    case MARK_CATEGORIES_LIST_STALE:
      return {
        ...state,
        categoriesListStale: true,
      };
    case CLEAR_CATEGORIES_LIST_STALE:
      return {
        ...state,
        categoriesListStale: false,
      };
    case MARK_WIDGETS_LIST_STALE:
      return {
        ...state,
        widgetsListStale: true,
      };
    case CLEAR_WIDGETS_LIST_STALE:
      return {
        ...state,
        widgetsListStale: false,
      };
    case MARK_SEO_LIST_STALE:
      return {
        ...state,
        seoListStale: true,
      };
    case CLEAR_SEO_LIST_STALE:
      return {
        ...state,
        seoListStale: false,
      };
    case MARK_INFORMATION_POLICY_LIST_STALE:
      return {
        ...state,
        informationPolicyListStale: true,
      };
    case CLEAR_INFORMATION_POLICY_LIST_STALE:
      return {
        ...state,
        informationPolicyListStale: false,
      };
    case MARK_ADMIN_SETTINGS_STALE:
      return {
        ...state,
        adminSettingsStale: true,
      };
    case CLEAR_ADMIN_SETTINGS_STALE:
      return {
        ...state,
        adminSettingsStale: false,
      };
    case MARK_CONFIG_SETTINGS_STALE:
      return {
        ...state,
        configSettingsStale: true,
      };
    case CLEAR_CONFIG_SETTINGS_STALE:
      return {
        ...state,
        configSettingsStale: false,
      };
    default:
      return state;
  }
};

export default pendingPublish;
